"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Announcement = void 0;
const resource_model_1 = require("./resource.model");
class Announcement extends resource_model_1.Resource {
    load(x) {
        super.load(x);
        this.content = this.clean(x.content, String);
        if (x.maintenance)
            this.maintenance = true;
    }
}
exports.Announcement = Announcement;
